<template>
  <v-flex xs12 sm6 md4 lg3>
    <v-card class="text-center ma-3" color="#FFF8E1">
      <v-card-title>
        <v-row align="center" no-gutters>
          <v-col cols="auto">
            <!-- Icon -->
            <!-- <v-icon color="primary">mdi-message-text</v-icon> -->
            <v-btn fab depressed small dark color="#fff">
              <v-icon color="#FF9900">mdi-currency-usd</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <!-- Name -->
            <div align="left" class="ml-4">
              <span class="text-h6 subheading cardText--text">FlexiFund</span>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text align="left" class="ml-3">
        <!-- Amount -->
        <div
          v-if="flexiFund"
          class="text-h6 cardTextAccent2--text font-weight-bold"
        >
          Kes.
          {{ flexiFund.data.flexiFund.balance.toFixed(1) }}
        </div>
        <div v-else class="text-h6 cardTextAccent2--text font-weight-bold">
          Kes. 0
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("wallets/fetchFlexiFund");
  },
  computed: {
    flexiFund() {
      return this.$store.getters["wallets/flexiFund"];
    },
  },
};
</script>
